import { isDefined } from "@utils/helpers";
import { RefObject, useEffect } from "react";
import { HUBO_MARKER_URL, ZOOM_INITIAL } from "../storeDirections.config";

let map: woosmap.map.Map | undefined = undefined

export const useMap = (
    mapElementRef: RefObject<HTMLDivElement>,
    center: woosmap.map.LatLngLiteral
) => {
    useEffect(() => {
        if (!isDefined(mapElementRef.current)) return;

        map ||= new woosmap.map.Map(mapElementRef.current, {
            center: center,
            zoom: ZOOM_INITIAL,
        });

        const marker = new woosmap.map.Marker({
            position: center,
            icon: HUBO_MARKER_URL,
            map: map,

        });

        marker.setMap(map);
    }, [])

    return map;
}
